import merge from 'lodash/merge.js';

import Collection from '@/store/quill/Collection.js';

export default merge(Collection('Help'), {
    state: {
        menu: null,
        article: null,
        breadcrumbs: ['Help'],
        showMobileMenu: false,
    },

    getters: {
        menu: state => state.menu,
        article: state => state.article,
        breadcrumbs: state => state.breadcrumbs,
        showMobileMenu: state => state.showMobileMenu,
    },

    actions: {
        async getHelpArticle({ dispatch }, payload) {
            const data = await dispatch('fetchAll', {
                endpoint: `help-articles/${payload.id}`,
                include: 'tags',
            });

            dispatch('updateArticle', data.data.data);
            dispatch('updateBreadcrumbs', data.data.breadcrumbs);

            return data.data.data;
        },

        updateArticle(context, payload) {
            context.commit('UPDATE_ARTICLE', payload);
        },

        updateBreadcrumbs(context, payload) {
            context.commit('UPDATE_BREADCRUMBS', payload);
        },
    },

    mutations: {
        UPDATE_MENU(state, payload) {
            state.menu = payload;
        },

        UPDATE_ARTICLE(state, payload) {
            state.article = payload;
        },

        UPDATE_BREADCRUMBS(state, payload) {
            state.breadcrumbs = payload;
        },

        PURGE(state) {
            state.article = null;
            state.breadcrumbs = ['Help'];
        },

        RESET_SHOW_MOBILE_MENU(state) {
            state.showMobileMenu = null;
        },

        TOGGLE_MOBILE_MENU(state) {
            state.showMobileMenu = !state.showMobileMenu;
        },
    },
});
